import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Paper, TextField, Button, Alert } from '@mui/material';
import { LockResetOutlined as LockIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useAuthStore } from '../store/authStore';

const ForgotPassword = () => {
  const forgotPassword = useAuthStore((s) => s.forgotPassword);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const res = await forgotPassword(email);
    setLoading(false);
    // Respuesta genérica anti-enumeración: mostramos confirmación siempre que el servidor responda
    if (res.success) setSent(true);
    else setError(res.error || 'No se pudo procesar la solicitud');
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
      <Container maxWidth="sm">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <Paper elevation={0} variant="outlined" sx={{ p: 4, borderRadius: 4, bgcolor: 'background.paper' }}>
            {sent ? (
              <Box sx={{ textAlign: 'center', py: 2 }}>
                <LockIcon color="primary" sx={{ fontSize: 56, mb: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Revisa tu correo</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  Si existe una cuenta asociada a <strong>{email}</strong>, te enviamos un enlace para
                  restablecer tu contraseña.
                </Typography>
                <Button component={Link} to="/login" variant="contained" size="large">Volver a iniciar sesión</Button>
              </Box>
            ) : (
              <>
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                  <LockIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
                  <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>Recuperar acceso</Typography>
                  <Typography variant="body1" color="text.secondary">
                    Te enviaremos un enlace para crear una nueva contraseña
                  </Typography>
                </Box>

                {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

                <form onSubmit={handleSubmit}>
                  <TextField
                    fullWidth
                    label="Correo electrónico"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    margin="normal"
                    required
                  />
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    type="submit"
                    disabled={loading}
                    sx={{ py: 1.5, mt: 3, fontWeight: 600 }}
                  >
                    {loading ? 'Enviando…' : 'Enviar enlace'}
                  </Button>
                </form>

                <Box sx={{ textAlign: 'center', mt: 3 }}>
                  <Link to="/login" style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" color="primary">Volver a iniciar sesión</Typography>
                  </Link>
                </Box>
              </>
            )}
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
